/**
 * ResponsavelConfigSms
 * @author Simpli CLI generator
 */
import {$, ID, Resource} from 'simpli-web-sdk'
import {
  ResponseSerialize,
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import Responsavel from '@/model/resource/Responsavel'
import StatusSms from '@/model/resource/StatusSms'
import ResponsavelConfigSmsSchema from '@/schema/ResponsavelConfigSms.schema'
import TipoOcorrencia from '@/model/resource/TipoOcorrencia'

export default class ResponsavelConfigSms extends Resource {
  readonly $name: string = 'ResponsavelConfigSms'

  readonly $endpoint: string = '/user/sms/configuracao{/id}'

  get $schema() {
    return ResponsavelConfigSmsSchema(this)
  }

  get $id() {
    return this.idConfigSmsPk
  }
  set $id(val: ID) {
    this.idConfigSmsPk = val
  }

  get isOcorrenciaSelected() {
    return this.statusSms && this.statusSms.idStatusPk === StatusSms.OCORRENCIA
  }

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  @ResponseSerialize(StatusSms)
  statusSms: StatusSms | null = null

  @ResponseSerialize(TipoOcorrencia)
  ocorrencia: TipoOcorrencia | null = null

  idConfigSmsPk: ID = 0

  @ValidationRequired()
  @ValidationMaxLength(2000)
  mensagem: string = ''

  @ValidationRequired()
  ativo: boolean = true

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(idResponsavelFk: ID) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = idResponsavelFk
  }

  idStatusFk: ID = 0

  async persistResponsavelConfigSms(model?: ResponsavelConfigSms, spinner = 'persistResponsavelConfigSms') {
    const fetch = async () => {
      if (model) await model.validate()
      return await this.POST(`/user/sms/configuracao`, model)
    }

    return await $.await.run(fetch, spinner)
  }

  async getResponsavelConfigSms(id: number, spinner = 'getResponsavelConfigSms') {
    const fetch = async () => await this.GET(`/user/sms/configuracao/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
